module.exports = __webpack_public_path__ + "img/718-75233b.png";